import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/sparkle-filled.vue
var o = {
	name: "DtIconSparkleFilled",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--sparkle-filled"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Sparkle Filled",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M9.263 11c.05 0 .093-.034.108-.082.23-.745.81-1.335 1.545-1.572A.12.12 0 0 0 11 9.233a.12.12 0 0 0-.084-.114c-.72-.232-1.29-.8-1.53-1.522a.131.131 0 0 0-.123-.092.131.131 0 0 0-.123.092 2.392 2.392 0 0 1-1.51 1.516.127.127 0 0 0-.087.12c0 .055.036.103.087.12a2.393 2.393 0 0 1 1.525 1.565.114.114 0 0 0 .107.082Zm-4.76-1.392a.23.23 0 0 0 .218-.166A4.872 4.872 0 0 1 7.868 6.24c.1-.033.17-.125.17-.23a.243.243 0 0 0-.17-.23 4.87 4.87 0 0 1-3.115-3.103.266.266 0 0 0-.25-.186.266.266 0 0 0-.25.186 4.872 4.872 0 0 1-3.076 3.09A.257.257 0 0 0 1 6.01c0 .111.073.208.177.243a4.872 4.872 0 0 1 3.107 3.19.23.23 0 0 0 .219.165Zm4.76-5.113c.05 0 .094-.034.108-.081.23-.746.81-1.335 1.545-1.572A.12.12 0 0 0 11 2.728a.12.12 0 0 0-.084-.114 2.388 2.388 0 0 1-1.529-1.522A.131.131 0 0 0 9.264 1a.131.131 0 0 0-.124.092 2.393 2.393 0 0 1-1.509 1.516.127.127 0 0 0-.087.12c0 .055.036.103.087.12a2.393 2.393 0 0 1 1.525 1.566.114.114 0 0 0 .108.081Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=sparkle-filled.js.map